var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"win-select"},[_c('span',{staticClass:"select-option",style:({
      'width': _vm.optionWidth
    })},[_vm._v(_vm._s(_vm.optionTit)+"：")]),_c('ul',{staticClass:"select-value"},_vm._l((_vm.newlists),function(item,key){return _c('li',{key:key,class:{
        'select-active': item.active
      },on:{"click":function($event){return _vm.toSelect(item.value)}}},[_vm._v(_vm._s(item.label))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }